<template>
	<div class="banner">
		<div class="swiper">
			<el-carousel height="450px">
				<el-carousel-item v-for="(item,index) in banner" :key="index" :duration="5000">
					<a :href="item.url" target="_blank">
						<img :src="$pub.imageUrl+item.address" alt="">
					</a>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="category">
			<div class="category-box">
				<div class="category-item" v-for="(item,index) in category" :key="index">
					<div class="category-main" @click="useCategory(item.id,'')">
						{{item.name}}
						<i class="el-icon-arrow-right"></i>
					</div>
					<div class="category-more">
						<div class="category-tab" v-for="(tab,tabIndex) in item['children']"
							@click="useCategory(item.id,tab.id)" :key="tabIndex">
							{{tab.name}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="login">
			<div class="avatar">
				<div class="avatar-circle">
					<img src="../../../assets/avatar-none.png" alt=""
						v-if="!$store.state.userinfo.headImg || !loginFlag">
					<img :src="$pub.imageUrl+$store.state.userinfo.headImg" alt="" v-else>
				</div>
				<br>
				<span v-if="!loginFlag">Hi，欢迎来到大德拍卖网。</span>
				<span v-else>{{$store.state.userinfo.username}}</span>
			</div>
			<div class="login-button" v-if="!loginFlag">
				<el-button type="danger" size="small" @click="openLogin">登录</el-button>
				<el-button type="danger" size="small" @click="goRegister">免费注册</el-button>
			</div>
			<div class="login-button" v-else>
				<el-button type="danger" size="small" @click="doLogout">退出登录</el-button>
				<el-button type="danger" size="small" @click="goSpace">个人中心</el-button>
			</div>
			<div class="phone">
				客服热线：{{$store.state.websiteConfig.contact[0]['value']}}
			</div>
			<div class="icons">
				<div class="icon-item" v-for="(item,index) in icons" :key="index">
					<img :src="item.icon" alt="">
					<br>
					{{item.name}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'banner',
		data() {
			return {
				banner: [],
				category: [],
				loginFlag: false,
				phone: '',
				icons: [{
						icon: require('../../../assets/icon-1.png'),
						name: '正规拍卖'
					},
					{
						icon: require('../../../assets/icon-2.png'),
						name: '交易保障'
					},
					{
						icon: require('../../../assets/icon-3.png'),
						name: '公开透明'
					}
				]
			};
		},
		computed: {
			loginStatus() {
				return this.$store.state.hasLogin
			}
		},
		watch: {
			loginStatus(flag) {
				this.loginFlag = flag
			}
		},
		methods: {
			...mapMutations(['logout']),
			openLogin() {
				this.$emit('openLogin')
			},
			goRegister() {
				this.$router.push({
					path: 'register'
				})
			},
			doLogout() {
				this.$confirm('请问是否确认退出登录？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					distinguishCancelAndClose: true,
					closeOnClickModal: false
				}).then(() => {
					this.$message({
						type: 'success',
						message: '退出登录成功',
						duration: 1500,
						onClose: () => {
							this.logout()
						}
					});
				}).catch(() => {});
			},
			goSpace() {
				this.$router.push({
					path: '/space'
				})
			},
			fetchSlider() {
				this.$api.frontIndexSlider({}, res => {
					if (res.code == 200) {
						this.banner = res.data
					}
				})
			},
			fetchCategory() {
				this.$api.frontCategory({}, res => {
					if (res.code == 200) {
						this.category = res.data
					}
				})
			},
			useCategory(firstId,secondId){
				this.$store.state.firstId = firstId
				this.$store.state.secondId = secondId
				this.$router.push({
					path:'/scene'
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.phone = this.$store.state.websiteConfig.contact[0]['value']
			this.loginFlag = this.$store.state.hasLogin
			this.userinfo = this.$store.state.userinfo
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchSlider()
			this.fetchCategory()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.banner {
		width: 100%;
		position: relative;

		.swiper {

			a,
			img {
				width: 100%;
				height: 100%;
				display: block;
			}
		}
	}

	.category {
		width: 210px;
		height: 400px;
		position: absolute;
		left: 50%;
		top: 25px;
		background: rgba(255, 255, 255, 0.9);
		z-index: 999;
		margin-left: -600px;
		border-radius: @vue-border-radius-base;

		.category-box {
			width: 100%;
			height: 100%;
			position: relative;
			padding: @vue-spacing-col-base 0px;
			box-sizing: border-box;
		}

		.category-item {
			width: 220px;
			height: 50px;

			.category-main {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				color: @vue-text-color;
				padding: 0px @vue-spacing-row-base+10px 0px @vue-spacing-row-base;
				box-sizing: border-box;
			}

			.category-more {
				width: calc(1200px - 460px);
				height: 400px;
				position: absolute;
				left: 220px;
				top: 0px;
				background: @vue-bg-color;
				display: none;
				background: rgba(255, 255, 255, 0.9);
				padding: @vue-spacing-col-base @vue-spacing-row-base;
				box-sizing: border-box;

				.category-tab {
					height: 50px;
					padding: 0px 15px;
					color: @vue-text-color;
					line-height: 50px;
				}

				.category-tab:hover {
					color: @vue-text-color-active;
				}
			}
		}

		.category-item:hover {
			.category-main {
				color: @vue-text-color-active;
			}

			.category-more {
				display: flex;
			}
		}
	}

	.login {
		width: 230px;
		height: 360px;
		position: absolute;
		left: 50%;
		margin-left: 370px;
		top: 40px;
		background: @vue-bg-color;
		z-index: 999;

		.avatar {
			width: 100%;
			height: 140px;
			text-align: center;
			padding-top: @vue-spacing-col-base;
			box-sizing: border-box;
			font-size: @vue-font-size-sm - 2px;

			.avatar-circle {
				width: 74px;
				height: 74px;
				border-radius: @vue-border-radius-circle;
				overflow: hidden;
				margin: 0 auto;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.login-button {
			width: 100%;
			height: 50px;
			border-bottom: 1px solid @vue-border-color;
			box-sizing: border-box;
			padding: 0px @vue-spacing-row-base;

			.el-button {
				width: 90px;
			}
		}

		.phone {
			width: 100%;
			height: 60px;
			display: flex;
			justify-content: center;
			align-items: center;
			color: @vue-text-color-red;
			font-size: @vue-font-size-sm + 2;
		}

		.icons {
			width: 100%;
			display: flex;
			justify-content: space-between;
			padding: 0px @vue-spacing-row-sm;
			box-sizing: border-box;

			.icon-item {
				width: 33.3%;
				text-align: center;
				padding-top: @vue-spacing-col-sm;
				font-size: @vue-font-size-sm - 2;

				img {
					margin-bottom: @vue-spacing-col-sm;
				}
			}
		}
	}
</style>
